import { render, staticRenderFns } from "./notice-add-or-update.vue?vue&type=template&id=1a4e018e&"
import script from "./notice-add-or-update.vue?vue&type=script&lang=js&"
export * from "./notice-add-or-update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports